import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { trackClick } from '../utils/analytics';

export const CrossSellCTA = ({ items, title, subtitle, pagePath }) => (
  <section className="py-16 bg-zinc-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {title && (
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-white mb-3">{title}</h2>
          {subtitle && <p className="text-zinc-400 text-lg max-w-2xl mx-auto">{subtitle}</p>}
        </div>
      )}
      <div className={`grid gap-6 ${items.length <= 2 ? 'md:grid-cols-2 max-w-4xl mx-auto' : items.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2 lg:grid-cols-4'}`}>
        {items.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            onClick={() => trackClick(`CrossSell: ${item.label}`, pagePath || '/')}
            className="group bg-zinc-800/50 border border-zinc-700/50 rounded-xl p-6 hover:border-red-600/50 hover:bg-zinc-800 transition-all"
            data-testid={`crosssell-${item.href.replace(/\//g, '-').slice(1)}`}
          >
            <p className="text-red-500 text-sm font-semibold mb-2 uppercase tracking-wider">{item.eyebrow}</p>
            <h3 className="text-white font-bold text-lg mb-2 group-hover:text-red-500 transition-colors">{item.label}</h3>
            <p className="text-zinc-400 text-sm mb-4 leading-relaxed">{item.desc}</p>
            <span className="text-red-500 text-sm font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
              Learn More <ArrowRight size={14} />
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export const EstimateCTA = ({ heading, subtext, pagePath }) => (
  <section className="py-16 bg-gradient-to-br from-red-700 to-red-900 relative overflow-hidden">
    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIuNSIgb3BhY2l0eT0iLjA2Ii8+PC9nPjwvc3ZnPg==')] opacity-30"></div>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{heading || 'Get Your Instant Estimate'}</h2>
      <p className="text-red-100 text-lg mb-8 max-w-2xl mx-auto">
        {subtext || 'See preliminary pricing for your project in minutes. No obligation, no pressure.'}
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/instant-estimate"
          onClick={() => trackClick('Instant Estimate CTA', pagePath || '/')}
          className="inline-flex items-center justify-center gap-2 bg-white text-red-700 font-bold text-lg px-8 py-4 rounded-lg hover:bg-zinc-100 transition-colors shadow-xl"
          data-testid="estimate-cta"
        >
          Get an Instant Estimate <ArrowRight size={18} />
        </Link>
        <a
          href="tel:8177235006"
          onClick={() => trackClick('Call CTA', pagePath || '/')}
          className="inline-flex items-center justify-center gap-2 border-2 border-white text-white font-bold text-lg px-8 py-4 rounded-lg hover:bg-white/10 transition-colors"
        >
          Call 817-723-5006
        </a>
      </div>
    </div>
  </section>
);
